import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Initialize Google Tag Manager
;
(function (w: Window & {
  dataLayer?: any[];
}, d: Document, s: string, l: string, i: string) {
  w[l as keyof Window] = w[l as keyof Window] as any[] || [];
  (w[l as keyof Window] as any[]).push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s) as HTMLScriptElement,
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode?.insertBefore(j, f);
})(window as any, document, 'script', 'dataLayer', 'GTM-KSNWGS2V');
render(<App data-id="element-5147" />, document.getElementById('root'));